import React from "react";
import { Busy } from "../presentational/busy";
import { Card } from "../presentational/card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/pro-light-svg-icons/faArrowCircleLeft";
import ReactGA from "react-ga";
import styles from "../../styles/panels/campaignThankYou.css";
import * as utilities from "../../middleware/utilities";

export class CampaignThankYou extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    ReactGA.pageview("/Spend/CampaignThankYou");
    utilities
      .isCodeValid(this.props.code)
      .then(valid => {
        if (!valid) {
          this.props.onCodeError();
        }
      })
      .catch(() => {
        this.props.onCodeError();
      });
  }
  renderNavigation() {
    return (
      <div className={styles.navigation}>
        <div className={styles.message}>
          <div
            className={styles.icon}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Back Button",
                label: "/Spend/CampaignThankYou"
              });
              this.props.onBack();
            }}
          >
            <FontAwesomeIcon icon={faArrowCircleLeft} />
          </div>
        </div>
      </div>
    );
  }
  renderAside() {
    return (
      <div className={styles.aside}>
        <div className={styles.commands}>
          <button
            className={styles.button + " " + styles.primary}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Continue Button",
                label: "/Spend/CampaignThankYou"
              });
              this.props.onContinue();
            }}
          >
            {this.props.dictionary.campaign_thank_you_continue}
          </button>
        </div>
        <Card
          src={this.props.donation.image}
          alt={this.props.donation.amount}
        />
      </div>
    );
  }
  render() {
    if (!this.props.code || this.props.busy) {
      return <Busy />;
    } else {
      return (
        <div className={styles.main}>
          {this.renderNavigation()}
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{
              __html: this.props.donation.campaignDetail.thankYouMarkup
            }}
          />
          {this.renderAside()}
        </div>
      );
    }
  }
}
